<template>
	<div class="com-mod-section-container">
		<div class="summary-module-container">
			<div class="row">
				<div class="col-md-12">
					<div class="disclosure pre com-mod-level-2-disclosure" />
				</div>
				<div v-if="purchaseRestriction" id="purchase-restriction" v-html="purchaseRestriction" />
				<div class="col-md-12">
					<div id="summary-header">
						<h3 class="com-mod-section-header">{{ title }}</h3>
					</div>
				</div>
			</div>
			<article>
				<summary-module />
			</article>
		</div>

		<div class="row">
			<div class="col-md-6">
				<article v-if="isAuthorizedModule['underlyingFunds']" id="_underlyingFunds">
					<div>
						<underlying-funds />
					</div>
				</article>
				<article v-if="isAuthorizedModule['returnsAtNav']" id="_returnsAtNav">
					<returns-at-nav />
				</article>
			</div>

			<div class="col-md-6">
				<article>
					<asset-mix />
				</article>

				<template v-if="isAuthorizedModule['fundStatistics']">
					<article id="_fundStatistics">
						<fund-statistics />
					</article>
				</template>

				<article v-if="isAuthorizedModule['returnsAtNav_position2']" id="_returnsAtNav_position2">
					<returns-at-nav />
				</article>
			</div>
		</div>

		<div
			v-if="isAuthorizedModule['returnsAtNav_position3'] && isAuthorizedModule['volatilityReturns']"
			class="row"
		>
			<article class="col-md-6 gray-bar-top" id="_volatilityReturns">
				<volatility-return />
			</article>
			<article class="col-md-6" id="_returnsAtNav_position3">
				<returns-at-nav />
			</article>
		</div>

		<div class="row">
			<div class="col-md-6">
				<article
					v-if="isAuthorizedModule['volatilityReturns_position2']"
					id="_volatilityReturns_position2"
					class="gray-bar-top"
				>
					<volatility-return />
				</article>
				<article v-if="isAuthorizedModule['growth10k']" id="_growth10k">
					<growth-10k />
				</article>
			</div>

			<div class="col-md-6">
				<div class="row">
					<article v-if="isAuthorizedModule['marketCap']" id="_marketCap" class="col-md-12">
						<div class="gray-bar-top">
							<market-capitalization />
						</div>
					</article>

					<article v-if="isAuthorizedModule['mStarOwnership']" id="_mStarOwnership" class="col-md-12">
						<mstar-ownership />
					</article>

					<div class="col-xs-12">
						<article v-if="isAuthorizedModule['fundStatistics_position2']" id="_fundStatistics_position2">
							<fund-statistics />
						</article>
						<article v-if="isAuthorizedModule['mStarStyle']" id="_mStarStyle">
							<morningstar-style />
						</article>
					</div>
				</div>
			</div>
		</div>
		<div>
			<div class="row">
				<div class="col-md-6">
					<article v-if="isAuthorizedModule['fundStatistics_position3']" id="_fundStatistics_position3">
						<fund-statistics />
					</article>
				</div>

				<div class="col-md-6">
					<article v-if="isAuthorizedModule['mStarStyle_position2']" id="_mStarStyle_position2">
						<morningstar-style />
					</article>
				</div>
			</div>
		</div>

		<div class="row">
			<div class="col-md-12">
				<article>
					<summary-description />
				</article>
			</div>
		</div>

		<div class="row">
			<div class="col-md-12">
				<article>
					<summary-facts />
				</article>
			</div>
		</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';
import SummaryModule from '../Modules/SummaryModule';
import ReturnsAtNav from '../Modules/ReturnsAtNav';
import AssetMix from '../Modules/AssetMix';
import Description from '../Modules/Description';
import Facts from '../Modules/FundFacts';
import FundStatistics from '../Modules/FundStatistics';
import MorningstarOwnershipZone from '../Modules/MorningstarOwnershipZone';
import MorningstarStyle from '../Modules/MorningstarStyle';
import VolatilityReturn from '../Modules/VolatilityReturnWrapper';
import MarketCapitalization from '../Modules/MarketCapitalization';
import Growth10k from '../Modules/Growth10kWrapper';
import UnderlyingFunds from '../Modules/UnderlyingFundsWrapper';

export default {
	name: 'SectionSummary',
	components: {
		AssetMix,
		FundStatistics,
		MorningstarStyle,
		VolatilityReturn,
		MarketCapitalization,
		Growth10k,
		UnderlyingFunds,
		ReturnsAtNav,
		'summary-module': SummaryModule,
		'summary-description': Description,
		'summary-facts': Facts,
		'mstar-ownership': MorningstarOwnershipZone
	},
	data() {
		return {
			title:
				this.$store.state.audience === 'institutional'
					? 'Overview'
					: 'Summary'
		};
	},
	computed: {
		...mapGetters([
			'getFundAttributes',
			'isManagedRisk',
			'isAFISTargetDate',
			'getFundAttributes',
			'purchaseRestrictions'
		]),
		purchaseRestriction() {
			return (
				(this.purchaseRestrictions &&
					this.purchaseRestrictions.RestrictionLanguage) ||
				null
			);
		}
	}
};
</script>
<style lang='less'>
#purchase-restriction {
	background-color: #fffcd5;
	padding: 15px;
	font-family: AvenirNextLTW01-Regular, Arial;
	font-size: 14px;
	color: #333;
	border-bottom: 1px solid #ccc;
}
</style>
